module.exports = __webpack_public_path__ + "img/06-identity.b516189c.png";